export default __webpack_public_path__ + "static/media/Item1.fff4f897.png";